import SocialList from "./social-list";
export default SocialList;